import { IBookWithProgress } from '@common/models/Books/Book';
import Modal, { IModalProps } from 'components/Modal';
import GrowTransition from 'components/Modal/animations/grow';
import BooksSection from 'modules/Books/layout/BooksSection';
import React from 'react';

interface PropsType extends Omit<IModalProps, 'children'> {
	books: IBookWithProgress[];
}

function BooksModal({ books, ...props }: PropsType) {
	return (
		<Modal
			{...props}
			TransitionComponent={GrowTransition}
			transitionDuration={500}
		>
			<BooksSection groupedBooks={books} />
		</Modal>
	);
}

export default BooksModal;
